import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';
import { Link } from 'gatsby';

import ExternalLinkIcon from '~components/common/ExternalLinkIcon';
import { stateEnums } from '~utils/enums';
import { TableData, TableRow } from '~components/common/Table';

import { rowRendererProps } from '../propTypes';

export default function BallotTrackerRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');
  const stateCode = stateEnums.find(
    (e) => e.option.toLowerCase() === stateName.toLowerCase()
  ).value;

  const {
    gov_tool_provisional_tracker: { text: trackerURL },
  } = stateData;

  function cellValue() {
    if (trackerURL) {
      return (
        <a
          href={trackerURL}
          target='_blank'
          rel='noopener'
          title={`${stateName} ballot tracker`}
        >
          {stateName} ballot tracker
          <ExternalLinkIcon />
        </a>
      );
    }

    return (
      <span>
        {stateName} does not have an online tracker. Call your{' '}
        <Link
          to={`/local-election-offices/${stateCode}/`}
          title='local election office'
        >
          local election office
        </Link>
        .
      </span>
    );
  }

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <TableData>{cellValue()}</TableData>
    </TableRow>
  );
}

BallotTrackerRowRenderer.propTypes = rowRendererProps;
